export const selectPositionEsLocale = {
  'select-position.choose': 'Elige tus tickets',
  'select-position.description': `Elige el tipo de ticket que deseas comprar. Máximo de {maxQuantity} tickets por persona.`,
  'select-position.location': 'Tickets',
  'select-position.quantity': 'Cantidad',
  'select-position.button.select': 'Continuar al pago',
  'select-position.quantity.placeholder': 'Seleccionar',
  'select-position.errors.position.required':
    'Por favor selecciona al menos un asiento',
  'select-position.errors.quantity.required':
    'No puedes seleccionar más de {maxQuantity} tickets',
  'select-position.venue-image': 'Imagen de recinto: ',
  'select-position.sold-out': 'Agotado',

  'select-position.loading': 'Seleccionando...',
  'select-position.success':
    'Tus tickets han sido reservados, por favor procede a realizar el pago',
  'select-position.fee': 'Recargos',

  'select-position.timeOutTitle': 'Se ha agotado el tiempo de reserva',

  'select-position.timeOutDescription':
    'El tiempo de reserva ha expirado, por favor selecciona nuevamente tus tickets',
  'select-position.close': 'Elegir tickets',

  'select-position.free': 'Gratis',

  'select-position.errors.minPurchase':
    'Debes seleccionar al menos {min} entradas para "{label}".',
} as const;

export const selectPositionEnLocale = {
  'select-position.choose': 'Choose your tickets',
  'select-position.description': `Choose your ticket type you want to buy. {maxQuantity} tickets max per buyer.`,
  'select-position.location': 'Tickets',
  'select-position.quantity': 'Quantity',
  'select-position.button.select': 'Proceed to payment',
  'select-position.quantity.placeholder': 'Select',
  'select-position.errors.position.required': 'Please select at least one seat',
  'select-position.errors.quantity.required':
    'You cannot select more than {maxQuantity} seats',
  'select-position.venue-image': 'Venue image: ',
  'select-position.sold-out': 'Sold out',

  'select-position.loading': 'Selecting...',
  'select-position.success':
    'Your seat has been reserved, please proceed to payment',
  'select-position.fee': 'Fees',

  'select-position.timeOutTitle': 'The reservation time has expired',

  'select-position.timeOutDescription':
    'The reservation time has expired, please select your tickets again',
  'select-position.close': 'Choose tickets',

  'select-position.free': 'Free',

  'select-position.errors.minPurchase':
    'You must select at least {min} tickets for "{label}".',
} as const;
